import { SOLUTION, SolutionType } from '../constants/solution/solution.constant';

// eslint-disable-next-line turbo/no-undeclared-env-vars
export const SOLUTION_TYPE: SolutionType = (process?.env?.NEXT_PUBLIC_SOLUTION_TYPE ??
  SOLUTION.JOBFLEX) as SolutionType;
export const SOLUTION_PATH_PREFIX = {
  JOBFLEX: (url: string, isExternal = false) => (isExternal ? url : `/career/${url}`),
  JOBDA: (url: string) => `/${url}`,
};
